import React from "react";

import { useInfoClubSettings } from "./hooks/useInfoClubSettings";

import InfoClubHeader from "./components/InfoClubHeader";
import InfoClubKpiCards from "./components/InfoClubKpiCards";
import InfoClubForm from "./components/InfoClubForm";
import InfoClubPreviewPanel from "./components/InfoClubPreviewPanel";

export default function SettingsInfoClub() {
  const dashboard = useInfoClubSettings();

  const formId = "info-club-settings-form";

  return (
    <div className="space-y-5">
      <InfoClubHeader
        formId={formId}
        saving={dashboard.saving}
        loading={dashboard.loading}
      />

      {/* <InfoClubKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <InfoClubForm
        formId={formId}
        settings={dashboard.settings}
        loading={dashboard.loading}
        saving={dashboard.saving}
        onChange={dashboard.handleChange}
        onContentChange={dashboard.handleContentChange}
        onToggleActive={dashboard.toggleActive}
        onSubmit={dashboard.saveSettings}
      />

      <InfoClubPreviewPanel
        settings={dashboard.settings}
        previewSettings={dashboard.previewSettings}
        previewDark={dashboard.previewDark}
        setPreviewDark={dashboard.setPreviewDark}
      />
    </div>
  );
}